import {hrmsWithPath} from '../../services/http/api/rest';

const rest = hrmsWithPath('/v1/policy');

const policy = {
    search: (pageNumber?: number, pageSize?: number, data?: any) => rest.post('/search', {}, data, {
        "page-size": pageSize,
        "page-number": pageNumber
    }),
    create: (data: any) => rest.post('', {}, data),
    get: (id: string) => rest.get('/{{id}}', {id}, {}),
    delete: (id: string) => rest.del('/{{id}}', {id}),
    notify: (id: string) => rest.post('/{{id}}/notify', {id}, {}, {}),
    update: (id: string, status: string, reason?: string) => rest.put('/{{id}}/update', {id}, {reason}, {
        "status": status,
    }),
}

export default policy;